import * as React from 'react';
import {SVG, SVGEnum} from '../../../HelperFunctions/SVG';
import {SpeedMultiplierEnum,PlayerStatusEnum} from "./CollisionTimeLineEnums"
import i18n from '../../../Translations/_i18n';
import moment from 'moment';

type HistoryTimeLineLabelP = {
    playSlowDataframe:(event:any)=>void;
    playDataframe:(event:any)=>void; 
    pauseDataframe:(event:any)=>void;
    playFastDataframe:(event:any)=>void;
    speedGps:number;
    acceleration:number;
    dateTime:string;
    speedMultiplier:SpeedMultiplierEnum;
    playerStatus:PlayerStatusEnum;
}

export class HistoryTimeLineLabel extends React.PureComponent<HistoryTimeLineLabelP> {
    public render() {
        const {speedGps,acceleration,dateTime,speedMultiplier,playerStatus} = this.props;
        return(
            <div className="historyTimeLine__group">
                <div className="historyTimeLine__toolbar"> 
                        <div onClick={this.props.playSlowDataframe} className={(speedMultiplier==SpeedMultiplierEnum.SPEED05)?"historyTimeLine__toolbar__btn--active":''}>        
                            <SVG type={SVGEnum.SLOW}/>
                        </div>
                        {
                            (playerStatus == PlayerStatusEnum.STOP)?
                            <div onClick={this.props.playDataframe}>
                                <SVG type={SVGEnum.PLAY} />
                            </div>
                            :
                            <div onClick={this.props.pauseDataframe}>
                                <SVG type={SVGEnum.STOP}/>
                            </div>
                        }
                        
                        <div onClick={this.props.playFastDataframe} className={(speedMultiplier==SpeedMultiplierEnum.SPEED2)?"historyTimeLine__toolbar__btn--active":''}>
                            <SVG type={SVGEnum.FAST}/>
                        </div>
                </div>
                {
                    <div className="historyTimeLine__label">
                        <span>{i18n.t('carDetails:speedGps')}: {speedGps.toFixed(2)} km/h</span> <span>{i18n.t('carDetails:acceleration')}: {acceleration.toFixed(2)} m/s<sup>2</sup></span> <span>{i18n.t('carDetails:time')}: {moment(dateTime).format('DD:MM:YYYY HH:mm:ss')}</span>
                    </div>
                }
            </div>  
        )
    } 
}



// WEBPACK FOOTER //
// ./src/components/History/CollisionTimeLine/HistoryTimeLineLabel.tsx